import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import { TableData } from '../common/components/TableData';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { Helper } from '../common/helpers/Helper';
import async from 'async';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppTheme } from '../styles/AppTheme';

export class Users extends Component {
  constructor(props) {
    super(props);
    this.slug = this.props.match.params.id ? this.props.match.params.id : null;
    this.state = {
      inProcess: false,
      addToSet: true,
      adminDialog: false,
      addUserDialog: false,
      dialogAction: '',
      dialogTitle: '',
      email: '',
      admin: false,
      regular: false,
      cred: '',
      selectedItem: {},
      userDelete: '',
      showDeleteError: false,
      fetchState: ApiHelperV2.State.LOADING,
      formFieldsValidity: {
        email: true,
        cred: true,
      },
      formFieldErrMsg: {
        email: '*Required',
        cred: '*Required',
      }
    }
    this.userFields = {
      email: {
        key: 'email',
        label: 'Email',
        type: 'text'
      },
      admin: {
        key: 'admin',
        label: 'ADMIN',
        type: 'text'
      },
      regular: {
        key: 'regular',
        label: 'REGULAR',
        type: 'text'
      },
      cred: {
        key: 'cred',
        label: 'New password',
        type: 'password'
      },
      userDelete: {
        key: 'userDelete',
        label: 'Type DELETE',
        type: 'text'
      }
    },
    this.navField = [
      {
        link: '/admin',
        title: 'Organisations',
        icon: 'account_balance'
      },
    ]
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })
    const thisObj = this;
    async.parallel(
      [
        function (callback) {
          ApiHelperV2.call(
            { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['users'], { orgId: thisObj.slug }) }, callback)
        },
        function (callback) {
          ApiHelperV2.call(
            { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['orgs', thisObj.slug]) }, callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.setState({
          userData: results[0],
          orgData: results[1],
          fetchState: ApiHelperV2.State.READY
        })
      }.bind(this))
  }


  add = () => {
    this.setState({
      addUserDialog: true
    })
  }

  edit = (item) => {
    this.setState({
      adminDialog: true,
      dialogAction: 'edit',
      dialogTitle: 'Edit user',
      selectedItem: item,
      email: item.email,
      cred: '',
      addToSet: false
    })
    item.orgs[0].roles.map(item => {
      if (item === 'ADMIN') {
        this.setState({ admin: true })
      }
      if (item === 'REGULAR') {
        this.setState({ regular: true })
      }
    })
  }

  delete = (item) => {
    item.orgs[0].roles.map(item => {
      if (item === 'ADMIN') {
        this.setState({ admin: true })
      }
      if (item === 'REGULAR') {
        this.setState({ regular: true })
      }
    })
    this.setState({
      adminDialog: true,
      dialogAction: 'delete',
      dialogTitle: 'Delete user',
      selectedItem: item,
      email: item.email,
      cred: ''
    })
  }

  dialogCloseValidation = () => {
    const formFieldsValidity = this.state.formFieldsValidity;
    formFieldsValidity.email = true;
    formFieldsValidity.cred = true;

    this.setState({
      formFieldsValidity: formFieldsValidity
    });
  }

  dialogClose = () => {
    const apiBody = this.dialogCloseValidation()
    this.setState({
      adminDialog: false,
      email: '',
      errMsg: '',
      inProcess: false,
      formFieldErrMsg: { email: '*Required' },
      dialogAction: '',
      dialogTitle: '',
      selectedItem: null,
      admin: false,
      regular: false,
      cred: '',
      showDeleteError: false,
    })
  }

  dialogUserClose = () => {
    const apiBody = this.dialogCloseValidation()
    this.setState({
      email: '',
      addUserDialog: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: null,
      errMsg: '',
      admin: false,
      regular: false,
      formFieldErrMsg: { email: '*Required' },
      inProcess: false,
      showDeleteError: false,
    })
  }

  change = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  getFieldErrorMsg = (formFieldKey) => {
    if (this.state.formFieldErrMsg[formFieldKey]) {
      return this.state.formFieldErrMsg[formFieldKey]
    }
    return '*Required'
  }

  generateTextField = (formField, data) => {
    let disabled = false
    let validity = {};
    validity = this.state.formFieldsValidity;

    if (this.state.dialogAction === 'delete') {
      if (formField.key === 'userDelete') {
        disabled = false
      } else {
        disabled = true
      }
    } else {
      disabled = false
    }

    if (this.state.dialogAction === 'edit') {
      if (formField.key === 'email') {
        disabled = true
      } else {
        disabled = false
      }
    }

    return (
      <TextField
        id={formField.key}
        label={formField.label}
        name={formField.key}
        className={css(Styles.inputCss)}
        value={data}
        onChange={e => this.change(e)}
        margin='normal'
        type={formField.type}
        helperText={this.state.dialogAction === 'delete' ? '' :
          validity[formField.key] ? '' : this.getFieldErrorMsg(formField.key)}
        error={this.state.dialogAction === 'delete' ? '' : !validity[formField.key]}
        disabled={disabled}
        InputProps={{
          classes: {
            root: css(Styles.textFieldContentInput),
          }
        }}
        InputLabelProps={{
          classes: {
            root: css(Styles.textFieldContent),
            focused: css(Styles.focused),
          }
        }}
      />
    )
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  generateCheckField = (formField) => {
    let disabled = ''
    if (this.state.dialogAction === 'delete') {
      if (formField.key === 'userDelete') {
        disabled = false
      } else {
        disabled = true
      }
    } else {
      disabled = false
    }

    return (
      <FormControlLabel
        classes={{
          root: css(Styles.userCheckbox),
          label: css(Styles.userCheckboxContent)
        }}
        control={
          <Checkbox
            checked={this.state[formField.key]}
            onChange={this.handleChange(formField.key)}
            value={this.state[formField.key]}
            disabled={disabled}
          />
        }
        label={formField.label}
      />
    )
  }

  validateFields = () => {
    const item = this.state;
    const formFieldsValidity = this.state.formFieldsValidity;
    if (!item.email || item.email.length === 0) {
      formFieldsValidity.email = false;
    } else if (!Helper.validateAndFormatEmailV2(this.state.email)) {
      formFieldsValidity.email = false;
      this.state.formFieldErrMsg.email = 'Please ente a valid email'
    } else {
      formFieldsValidity.email = true;
    }
    if (this.state.dialogAction === 'add') {
      if (!item.cred || item.cred.length === 0) {
        formFieldsValidity.cred = false;
      } else {
        formFieldsValidity.cred = true;
      }
    }

    this.setState({
      formFieldsValidity: formFieldsValidity
    });

    for (const key in formFieldsValidity) {
      if (formFieldsValidity[key] === false) {
        return false
      }
    }

    const apiBody = {
      email: item.email,
      cred: item.cred,
    }
    return apiBody;
  }

  setSubmitUser = () => {
    let addToSet = true;
    if (this.state.userDataExist) {
      const data = this.state.userDataExist;
      if (data.orgs) {
        addToSet = true;
        for (const org of data.orgs) {
          if (org._id === this.slug) {
            addToSet = false;
            for (const role of org.roles) {
              if (role === 'ADMIN') {
                this.setState({ admin: true })
              }
              if (role === 'REGULAR') {
                this.setState({ regular: true })
              }
            }
          }
        }
      } else {
        addToSet = true;
      }
      this.setState({
        addUserDialog: false,
        adminDialog: true,
        dialogAction: 'edit',
        dialogTitle: 'Edit user',
        email: this.state.userDataExist.email,
        cred: '',
        selectedItem: this.state.userDataExist,
        addToSet: addToSet,
      })
    } else {
      this.setState({
        addUserDialog: false,
        adminDialog: true,
        dialogAction: 'add',
        dialogTitle: 'Add user',
        selectedItem: {},
        email: this.state.email,
        cred: '',
        addToSet: true,
      })
    }
  }

  submitUser = () => {
    const apiBody = this.validateFields();
    if (apiBody) {
      this.setState({
        inProcess: true
      })
      ApiHelperV2.call(
        { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['users'], { orgId: this.slug, email: this.state.email }) },
        function (err, results) {
          if (err) {
            if (err.original && err.original.status === 404) {
              this.setState({
                inProcess: false,
              })
              this.setSubmitUser()
            } else {
              this.setState({
                errMsg: Helper.getErrorMsg(err)
              })
            }
            return
          }
          this.setState({
            userDataExist: results,
            inProcess: false,
          }, () => this.setSubmitUser())
        }.bind(this))
    }
  }

  submitOrg = (id) => {
    const apiBody = this.validateFields();
    let options = {};
    const selectRoles = [];
    if (this.state.admin) {
      selectRoles.push('ADMIN')
    }
    if (this.state.regular) {
      selectRoles.push('REGULAR')
    }
    if (apiBody) {
      this.setState({
        inProcess: true
      })
      if (!id) {
        options = {
          method: 'POST',
          endPoint: ApiHelperV2.makeUrlPath(['user']),
          jsonBody: {
            userData: {
              email: this.state.email,
              orgIds: [this.slug],
              org: {
                _id: this.slug,
                roles: selectRoles
              },
              cred: this.state.cred,
              addToSet: true,
            }
          }
        }
      } else {
        const body = {
          userData: {
            email: this.state.email,
            orgIds: [this.slug],
            org: {
              _id: this.slug,
              roles: selectRoles
            },
            addToSet: this.state.addToSet,
          }
        }
        if (this.state.cred && this.state.cred.length > 0) {
          body.userData.cred = this.state.cred
        }
        options = {
          method: 'PUT',
          endPoint: ApiHelperV2.makeUrlPath(['user', id]),
          jsonBody: body
        }
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            errCode: err.respCode,
            inProcess: false,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            email: '',
            admin: false,
            regular: false,
            cred: '',
          }), () => this.fetchItems());
        }
      }.bind(this))
    }
  }

  deleteOrg = (id) => {
    if (this.state.userDelete === 'DELETE') {
      this.setState({
        inProcess: true
      })
      const options = {
        method: 'DELETE',
        endPoint: ApiHelperV2.makeUrlPath(['user', id], { orgId: this.slug }),
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            errCode: err.respCode,
            inProcess: false,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            email: '',
            admin: false,
            regular: false,
            cred: '',
            showDeleteError: false,
          }), () => this.fetchItems());
        }
      }.bind(this))
    } else {
      this.setState({ showDeleteError: true })
    }
  }

  addUserDialog = () => {
    return (
      <Dialog
        onClose={this.dialogUserClose}
        open={this.state.addUserDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>Add user</p>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.generateTextField(this.userFields.email)}
          </div>
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            disabled={this.state.inProcess}
            variant='contained'
            onClick={() => this.submitUser()}
            className={css(Styles.actionButton)}>
            Next
            {this.state.inProcess && <CircularProgress color='primary' size={20} className={css(CommonStyles.marginLeft)} />}
          </Button>
          <Button
            variant='contained'
            onClick={() => this.dialogUserClose()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
        </DialogActions>
        {this.state.errMsg &&
          <p className={css(Styles.deleteMsg)}>{this.state.errMsg}</p>
        }
      </Dialog>
    )
  }

  renderDialog = (dialogAction, title) => {
    return (
      <Dialog
        onClose={this.dialogClose}
        open={this.state.adminDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>{title}</p>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.generateTextField(this.userFields.email, this.state.email)}
            {this.generateCheckField(this.userFields.admin)}
            {this.generateCheckField(this.userFields.regular)}
            <p className={css(Styles.passwordText)}>Required only if you wish to change your password</p>
            {this.generateTextField(this.userFields.cred, this.state.cred)}
          </div>
          {dialogAction === 'delete' &&
            <div className={css(Styles.fieldsContainer)}>
              {this.generateTextField(this.userFields.userDelete)}
            </div>
          }
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            disabled={this.state.inProcess}
            variant='contained'
            onClick={this.state.dialogAction === 'delete' ? e => this.deleteOrg(this.state.selectedItem._id) :
              e => this.submitOrg(this.state.selectedItem._id)}
            className={css(Styles.actionButton)}>
            {this.state.dialogAction === 'delete' ? 'Delete' : 'Submit'}
            {this.state.inProcess && <CircularProgress color='primary' size={20} className={css(CommonStyles.marginLeft)} />}
          </Button>
          <Button
            variant='contained'
            onClick={() => this.dialogClose()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
        </DialogActions>
        {this.state.showDeleteError && this.state.dialogAction === 'delete' &&
          <p className={css(Styles.deleteMsg)}>*Enter DELETE Correctly</p>
        }
        {this.state.errMsg &&
          <p className={css(Styles.deleteMsg)}>{this.state.errMsg}</p>
        }
      </Dialog>
    );
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div className={css(Styles.navOuterContainer)}>
          {this.navField.map(nav => {
            return (
              <Link to={{ pathname: nav.link }} className={css(Styles.navLink)}>
                <Icon className={css(Styles.navIcon)} color='secondary' >
                  {nav.icon}
                </Icon>
                <p className={css(Styles.navTitle)}>{nav.title}</p>
              </Link>
            )
          })}
          {this.state.orgData &&
            <p className={css(Styles.navSelected)}>{this.state.orgData.name}</p>
          }
        </div>
        <TableData
          titleIcon='person'
          titleText='USERS'
          columnTitle={['User ID', 'Email']}
          tableData={this.state.userData}
          icons={[
            {
              title: 'create',
              funcName: 'editFunction'
            },
            {
              title: 'delete',
              funcName: 'deleteFunction'
            }
          ]}
          addFunction={this.add}
          editFunction={this.edit}
          deleteFunction={this.delete}
        />
        {this.addUserDialog()}
        {this.renderDialog(this.state.dialogAction, this.state.dialogTitle)}
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '95%',
  },
  navOuterContainer: {
    display: 'flex',
    marginBottom: 20
  },
  navLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    backgroundColor:AppTheme.secondaryBg,
    marginRight: 10,
    padding: 5
  },
  navIcon: {
    marginRight: 5,
    fontSize: 35
  },
  navTitle: {
    fontWeight: 600,
    fontSize: 18,
    margin: 0
  },
  navSelected: {
    fontWeight: 'bolder',
    fontSize: 20,
    margin: 0,
    marginLeft: 10,
    alignItems: 'center',
    display: 'flex'
  },
  inputCss: {
    margin: '5px 0px 10px 0px',
    flex: 1,
    color: '#757575'
  },
  userCheckbox: {
    height: 30,
  },
  userCheckboxContent: {
    color: '#757575',
    fontWeight: 'bold',
    fontSize: 18
  },
  dialog: {
    minWidth: 500,
    '@media(max-width: 767px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    borderBottom: '2px solid whitesmoke',
    padding: 20,
    backgroundColor: '#303E8A',
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 25,
    margin: 0,
    color: 'white'
  },
  dialogContent: {
    padding: '0px 20px',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  passwordText: {
    fontWeight: 600,
    marginBottom: 5
  },
  dialogActions: {
    margin: 20,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    marginRight: 5,
    fontSize: 16,
    textTransform: 'unset'
  },
  textFieldContentInput: {
    color: 'black',
    fontWeight: 600,
    ':before': {
      borderBottom: '2px solid #757575',
    },
    ':after': {
      borderBottom: '2px solid #3F51B5',
    },
  },
  textFieldContent: {
    color: '#757575',
  },
  focused: {
    color: '#3F51B5',
    fontWeight: 'bold'
  },
  deleteMsg: {
    margin: 20,
    marginTop: 0,
    fontWeight: 'bold',
    color: 'red',
    fontSize: 15
  },
})



// WEBPACK FOOTER //
// ./src/screens/Users.js